import ddt from '@wix/da-ddt';
import { reduxKey } from './constants';
import { ChatWindowMode } from '../ChatWindow/types';
import noop from '../../utils/noop';
function getState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
// Status
export var getChatServiceStatus = function (state) { return getState(state).chatServiceStatus; };
// Auth
export var getChatAuthToken = function (state) { return getState(state).chatAuthToken; };
export var getShowOverlayChatList = function (state) {
    return getState(state).showOverlayChatList || false;
};
export var getShowOverlayNewChatWindow = function (state) {
    return getState(state).showOverlayNewChatWindow || false;
};
export var getNewChatParticipants = function (state) {
    return getState(state).newChatParticipants;
};
export var getPendingNewChatMessage = function (state) {
    return getState(state).pendingNewChatMessage;
};
export var isChatReduxReady = function (state) { return !!state[reduxKey]; };
// Chat list data
export var getChatListSubscriptionState = function (state) {
    return getState(state).chatListSubscriptionState;
};
export var getChatListError = function (state) {
    return getState(state).chatListSubscriptionStateError;
};
export var getChatListFetchMore = function (state) { var _a, _b; return _b = (_a = getState(state).chatListSubscription) === null || _a === void 0 ? void 0 : _a.fetchMore, (_b !== null && _b !== void 0 ? _b : noop); };
export var getChatListCursor = function (state) { var _a; return (_a = getState(state)) === null || _a === void 0 ? void 0 : _a.chatsCursor; };
export var getChatListChats = function (state) { return getState(state).chats; };
export var getChatListStatus = function (state) { return getState(state).chatsStatus; };
export var getChatUnreadCount = function (state) { var _a; return ((_a = getState(state).globalUnreadCount) === null || _a === void 0 ? void 0 : _a.count) || 0; };
export var getChatListIsReady = function (state) {
    var _a, _b;
    var chatListSubscriptionState = getChatListSubscriptionState(state);
    var chatListStatus = getChatListStatus(state);
    return (isChatReduxReady(state) &&
        chatListSubscriptionState === 'listening' &&
        ((_a = chatListStatus) === null || _a === void 0 ? void 0 : _a.isFetchingRooms) === false &&
        ((_b = chatListStatus) === null || _b === void 0 ? void 0 : _b.isFetchingRoom) === false);
};
export var getOpenChatrooms = function (state) { return getState(state).chatrooms; };
export var getOpenChatroomsOrder = function (state) {
    return getState(state).openChatroomsOrder;
};
/** Returns ordered list of chatroom ids for rooms that have been subscribed to
 *  and had their data loaded */
export var getOpenLoadedChatroomIds = function (state) {
    var _a, _b;
    var openChatroomsOrder = getOpenChatroomsOrder(state) || [];
    var openChatrooms = getOpenChatrooms(state) || {};
    var openAndLoadedIds = [];
    for (var _i = 0, openChatroomsOrder_1 = openChatroomsOrder; _i < openChatroomsOrder_1.length; _i++) {
        var id = openChatroomsOrder_1[_i];
        // TODO: would be more suitable to use: status?.isFetchingRoom === false
        // but causes a flash as the new rooms seem to init with `isFetchingRoom: false`
        var isLoaded = (_b = (_a = openChatrooms[id]) === null || _a === void 0 ? void 0 : _a.room) === null || _b === void 0 ? void 0 : _b.name;
        if (isLoaded) {
            openAndLoadedIds.push(id);
        }
    }
    return openAndLoadedIds;
};
var defaultChatroomValue = {};
export var getChatroom = function (state, chatId) {
    var chatrooms = getState(state).chatrooms;
    if (chatrooms && chatrooms.hasOwnProperty(chatId)) {
        return chatrooms[chatId];
    }
    else {
        ddt.log('chat', "We tried to get a chatroom that wasn't inside of our store -- chatroom id [" + chatId + "]");
        return defaultChatroomValue;
    }
};
/** Return a list of chatroom ids of open chat windows that are currently minimized */
export var getMinimizedChatWindows = function (state) {
    var chatrooms = getOpenChatrooms(state) || {};
    var openChatroomsOrder = getOpenChatroomsOrder(state) || [];
    return Object.keys(chatrooms).filter(function (id) {
        var chatroom = chatrooms[id];
        // because a closed room's data persists in `chatrooms` even after it's closed,
        // we also need to check this array to see if it's been closed
        var isOpen = openChatroomsOrder.includes(id);
        return chatroom && isOpen && chatroom.mode === ChatWindowMode.MINIMIZED;
    });
};
export var getChatsWithNewMsgs = function (state) { return getState(state).chatsWithNewMsgs; };
//# sourceMappingURL=selectors.js.map